import * as authServices from '@/services/authServices';
import * as userServices from '@/services/userServices';
import * as storageServices from '@/services/storageServices';
import * as doronServices from '@/services/doronServices';
import moment from 'moment';

export default {
  async createUser({ commit }, payload) {
    await authServices.createUser(payload.email, payload.password);

    const uid = authServices.getUID();
    if (!uid) {
      throw "not created";
    }

    // upload photo file and get this url
    const storageFolderPath = `users/${uid}/icon`;
    const photoURL = await storageServices.uploadPhoto(
      storageFolderPath,
      payload.photoFile
    );

    // update user doc
    const userDoc = {
      nickname: payload.nickname,
      birthDate: payload.birthDate,
      userType: payload.userType,
      selfIntroduction: '',
      // アクションで受け取ったpayloadにphotoFileがない場合は、defaultPhotoUrlを送信。
      photoURL: photoURL || payload.defaultPhotoUrl,
      isStreaming: false,
      ivsChannelArn: '',
      ivsStreamKeyArn: '',
      recentLiveId: ''
    };

    const userData = await userServices.createUserDoc(uid, userDoc);

    // init doron doc
    const doronDoc = {
      freeAmount: 500,
      amount: 0,
      unUsedDoron: [],
      unUsedFreeDoron: [
        {
          total: 500,
          remain: 500,
          expireAt: moment
            .unix(userData.createdAt.seconds)
            .add(1, 'years')
            .toDate()
        }
      ],
      usedDoron: [],
      usedFreeDoron: []
    };
    const doronData = await doronServices.updateDoronDoc(uid, doronDoc);

    // update state
    const user = authServices.getFirebaseUser();
    const { email, providerData, emailVerified } = user;
    await commit('auth/onAuthStateChanged', {
      uid,
      email,
      providerData,
      emailVerified
    });
    await authServices.setSigninDateTime(uid);
    commit('user/loadUserDoc', userData);
    commit('doron/updateDoronDoc', doronData);

    authServices.sendEmailVerification();

    return uid;
  }
};
